import { AlertTriangle } from "lucide-react";
import { CountdownTimer } from "./CountdownTimer";

export const UploadWarning = () => {
  return (
    <div className="bg-orange-50 border-l-4 border-orange-500 p-3 mb-4 rounded-lg animate-pulse max-w-lg">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 text-orange-500 mt-0.5 flex-shrink-0" />
        <div className="space-y-2">
          <p className="text-sm text-orange-700 leading-tight">
            <span className="font-semibold">Time-sensitive:</span> Please upload your documents within the next 24 hours.
          </p>
          <div className="flex items-center gap-2">
            <span className="text-xs text-orange-600">Time remaining:</span>
            <CountdownTimer />
          </div>
        </div>
      </div>
    </div>
  );
};